// Werkzeug-Dock (Prototyp E-Mail): kleine App-Icons in einer dunklen Kapsel; Punkt = Werkzeug ist aktiv
// (z. B. Signatur gewählt), heller Ring = sein Popover ist offen.
import type { Icon } from '@phosphor-icons/react';
import { CircleNotch } from '@phosphor-icons/react';
import { FORM, GLANZ } from './form-stil';

export interface FormDockEintrag {
  key: string;
  /** Beschriftung für Screenreader und Tooltip (Text aus dem Code) */
  label: string;
  icon: Icon;
  verlauf: string;
  onClick: () => void;
  offen?: boolean;
  punkt?: boolean;
  laedt?: boolean;
  gesperrt?: boolean;
}

export function FormDock({ eintraege, beschriftung, schmal }: { eintraege: readonly FormDockEintrag[]; beschriftung: string; schmal?: boolean }) {
  const k = schmal ? 36 : 40;
  return (
    <div role="toolbar" aria-label={beschriftung} className="flex min-w-0 items-center overflow-x-auto"
      style={{ gap: 2, padding: 4, borderRadius: 15, background: 'rgba(0,0,0,0.25)', boxShadow: 'inset 0 0 0 0.5px rgba(255,255,255,0.06)', scrollbarWidth: 'none' }}>
      {eintraege.map(e => {
        const I = e.laedt ? CircleNotch : e.icon;
        return (
          <button key={e.key} type="button" onClick={e.onClick} disabled={e.gesperrt || e.laedt} aria-label={e.label} aria-expanded={e.offen}
            data-tip={e.label}
            className="pf-kachel relative flex shrink-0 cursor-pointer items-center justify-center border-none disabled:cursor-not-allowed"
            style={{ width: k, height: k, borderRadius: 11, background: e.offen ? 'rgba(255,255,255,0.1)' : 'transparent', opacity: e.gesperrt ? 0.5 : 1 }}>
            <span aria-hidden className="relative flex items-center justify-center overflow-hidden" style={{
              width: 28, height: 28, borderRadius: 8, background: e.verlauf, transition: 'all .3s',
              boxShadow: e.offen
                ? 'inset 0 1px 1px rgba(255,255,255,0.5),0 0 0 2px rgba(255,255,255,0.85),0 6px 14px -4px rgba(0,0,0,0.7)'
                : 'inset 0 1px 1px rgba(255,255,255,0.45),inset 0 -2px 3px rgba(0,0,0,0.18),0 4px 10px -4px rgba(0,0,0,0.6)',
            }}>
              <span className="absolute inset-0" style={{ background: GLANZ }} />
              <I size={15} weight="fill" color="#fff" className={e.laedt ? 'pille-dreh relative' : 'relative'} />
            </span>
            {e.punkt && (
              <span aria-hidden className="absolute rounded-full" style={{ bottom: 2, left: '50%', width: 4, height: 4, marginLeft: -2, background: FORM.gold, boxShadow: `0 0 6px ${FORM.gold}` }} />
            )}
          </button>
        );
      })}
    </div>
  );
}
